import React from "react"
import { Modal } from "components/Core"
import { HiPlus, HiClipboardCopy } from "react-icons/hi"
import DataGroup from "../DataGroup"
import DataItem from "../DataItem"

interface ItemPreviewModalProps {
  isOpen: boolean
  onClose: () => void
  selectedItem: any
}

const ItemPreviewModal = ({ isOpen, onClose, selectedItem }: ItemPreviewModalProps) => (
  <Modal
    mounted={isOpen}
    className="!w-[550px] !max-w-[95vw] shadow-2xl border border-gray-100 overflow-hidden"
  >
    <div className="w-full bg-[#F2F2F7] flex flex-col h-[85vh] max-h-[800px]">
      {/* Header */}
      <div className="p-6 border-b border-gray-200 bg-white/50 backdrop-blur-md">
        <div className="flex flex-row justify-between items-start">
          <div className="flex flex-col">
            <span className="text-[12px] font-bold text-gray-400 uppercase tracking-widest mb-1">
              Vista Previa de Serie
            </span>
            <h2 className="text-[28px] font-black text-[#F9004D] leading-none mb-1">{selectedItem?.sku}</h2>
            <p className="text-[16px] font-medium text-gray-600 line-clamp-1">{selectedItem?.serieSap}</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-200/50 rounded-full transition-colors"
          >
            <HiPlus className="text-2xl text-gray-400 transform rotate-45" />
          </button>
        </div>
      </div>

      {/* Content Scrollable */}
      <div className="flex-1 overflow-y-auto p-6 flex flex-col gap-2">
        <DataGroup title="Detalle General">
          <DataItem label="SKU" value={selectedItem?.sku} />
          <DataItem label="Serie SAP" value={selectedItem?.serieSap} />
          <DataItem label="Estado Omnix" value={selectedItem?.estadoOmnix} />
          <DataItem label="Estado SAP" value={selectedItem?.estadoSap || "—"} />
          <DataItem
            label="Tienda"
            value={
              selectedItem?.calculated?.sources?.length > 0
                ? selectedItem.calculated.sources.map((s: any) => `${s.id} (${s.name})`).join(", ")
                : selectedItem?.almacen || "[Sin tienda]"
            }
          />
          <DataItem label="Disponible" value={selectedItem?.isAvailable ? "Sí" : "No"} />
          <DataItem label="Clase SKU" value={selectedItem?.claseSku} />
          <DataItem label="Tipo SKU" value={selectedItem?.tipoSku} last />
        </DataGroup>

        <DataGroup title="Cantidades">
          <DataItem label="Libre" value={selectedItem?.cantLibre} />
          <DataItem label="Bloqueado" value={selectedItem?.cantBloqueado} />
          <DataItem label="Reservado" value={selectedItem?.cantReservado} last />
        </DataGroup>

        <DataGroup title="Ubicación">
          <DataItem label="Centro" value={selectedItem?.centro} />
          <DataItem label="Almacén" value={selectedItem?.almacen} />
          <DataItem label="Subalmacén" value={selectedItem?.subalmacen} />
          <DataItem label="Nombre Bodega" value={selectedItem?.nomBodega} />
          <DataItem label="Alm Recep" value={selectedItem?.almRecep} />
          <DataItem label="Sociedad" value={selectedItem?.sociedad} last />
        </DataGroup>

        <DataGroup title="Movimiento">
          <DataItem label="Estado Stock" value={selectedItem?.estStock} />
          <DataItem label="Último Movimiento" value={selectedItem?.ultMov} />
          <DataItem label="Fecha Último Movimiento" value={selectedItem?.fechaUltMov} last />
        </DataGroup>

        {selectedItem?._omnixStateMachine?.currentState && (
          <DataGroup title="Estado de Máquina" themeColor="teal-500">
            <DataItem label="Estado" value={selectedItem._omnixStateMachine.currentState.state?.name} />
            <DataItem label="Acción" value={selectedItem._omnixStateMachine.currentState.action?.name} />
            <DataItem
              label="Fecha"
              value={
                selectedItem._omnixStateMachine.currentState.date
                  ? new Date(selectedItem._omnixStateMachine.currentState.date).toLocaleString("es-PE")
                  : "—"
              }
              last
            />
          </DataGroup>
        )}

        <DataGroup title="Metadata Completa" themeColor="indigo-500">
          <div className="p-4 bg-gray-50 flex flex-col gap-3">
            <div className="flex justify-end">
              <button
                onClick={() => {
                  navigator.clipboard.writeText(JSON.stringify(selectedItem, null, 2))
                }}
                className="flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-200 rounded-lg text-[11px] font-bold text-gray-500 hover:text-indigo-600 hover:border-indigo-100 hover:bg-indigo-50 shadow-sm transition-all active:scale-95"
              >
                <HiClipboardCopy className="text-sm" />
                Copiar JSON
              </button>
            </div>
            <pre className="text-[11px] font-mono text-gray-600 bg-white p-4 rounded-xl border border-gray-100 overflow-x-auto leading-relaxed shadow-inner max-h-[300px]">
              {JSON.stringify(selectedItem, null, 2)}
            </pre>
          </div>
        </DataGroup>
      </div>
    </div>
  </Modal>
)

export default ItemPreviewModal
